module.exports = __webpack_public_path__ + "static/founder-2-27357efdd9ce4aaa7e87ff1e51d63db6.png";